import styled from 'styled-components'
import { View } from '@olxbr/design-system'

const CrossWrapper = styled(View)`
  display: flex;
  border-radius: 31px;
  width: 31px;
  height: 31px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  :hover {
    background-color: #e5e5e5;
    transition: background-color 0.1s ease-in;
  }
`

export default CrossWrapper
